module.exports = __webpack_public_path__ + "static/img/bgLogo.100aaa5d.svg";